import React, { useState, useEffect } from 'react';
import axios from "axios";

export const committeeCache = {};

export default function CommitteeName({ committeeId, legislatureId }) {
    const [committeeName, setCommitteeName] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    async function fetchStandingCommitteeData(standingCommitteeId, legislatureId) {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_LAWS_BACKEND_HOST}/committees/v1/standingCommittees/search?limit=1&offset=0`,
                {
                    standingCommitteeIds: [standingCommitteeId],
                    legislatureIds: [legislatureId]
                },
                {
                    headers: {
                        'accept': 'application/json',
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error("Error fetching committee data: ", error);
            throw error;
        }
    }

    useEffect(() => {
        async function loadCommitteeName() {
            if (!committeeId) {
                setCommitteeName(null);
                setLoading(false);
                return;
            }

            const cacheKey = `${committeeId}-${legislatureId}`;

            if (committeeCache[cacheKey]) {
                setCommitteeName(committeeCache[cacheKey]);
                setLoading(false);
                return;
            }

            setLoading(true);
            try {
                const data = await fetchStandingCommitteeData(committeeId, legislatureId);
                const name = data?.content?.[0]?.committeeDetails?.committeeCode?.name || '';
                setCommitteeName(name);
                committeeCache[cacheKey] = name;
            } catch (err) {
                console.error("Error loading committee name:", err);
                setError(err);
            } finally {
                setLoading(false);
            }
        }

        loadCommitteeName();
    }, [committeeId, legislatureId]);

    if (loading) return <span>Loading...</span>;
    if (error) return <span>Error: {error.message}</span>;
    if (!committeeName) return <span>{committeeId || ''}</span>;

    return (
        <a href={`${process.env.REACT_APP_COMMITTEE_EXPLORER_URI}/#/standingCommittees/${committeeId}`}  target="_blank" rel="noopener noreferrer">
            {committeeName}
        </a>
    );

}